  const reducer = (prevState, action) => {
    switch (action.type) {
      case 'SET_LOADING':
        return {
          ...prevState,
          loading: action.loading
        }
      case 'RESTORE_TOKEN':
        return {
          ...prevState,
          token: action.token,
          userInfo: action.userInfo,
          forms: action.forms,
          loading: false
        }
      case 'INIT_TOKEN':
        return {
          ...prevState,
          token: action.token,
          userInfo: action.userInfo,
          forms: action.forms,
          loading: false,
        }
      case 'LOGOUT':
        return {
          ...prevState,
          token: null,
          userInfo: null,
          forms: null,
        }
      case 'CHANGE_MENU_KEY':
        return {
          ...prevState,
          menuKey: action.key,
        }
      case 'CHANGE_THEME':
        return {
          ...prevState,
          theme: action.status
        };    
      case 'CONNECTION_SOCKET':
        return {
          ...prevState,
          socket: action.socket
        }
      case 'SAVE_EMP_PROFILE_DATA':
        return {
          ...prevState,
          empProfileData: action.data
        }
      case 'SET_ERROR_STATUS': 
        return {
          ...prevState,
          error: action.error,
        }
      default:
        return prevState;
    }
  }

  export default reducer
